import BankingOperation from '../../Operation'
import PixQrForm from '../../Forms/PixQrForm'

/*
  O site não lê QR pela câmera — quem tem o celular na mão usa o app. Aqui o código chega
  colado, que é o caso real de quem recebe a cobrança por e-mail ou por mensagem no
  computador.
*/
export default function BankingPixQrCode ({ requestConfig, onCompleted, ...props }) {
  return (
    <BankingOperation title='Área Pix' {...props}>
      {({ availableBalance }) => (
        <PixQrForm
          availableBalance={availableBalance}
          requestConfig={requestConfig}
          onCompleted={onCompleted}
        />
      )}
    </BankingOperation>
  )
}
